<template>
    <div class="home-head-container">
        <div class="left-header-container"></div>
        <div class="middle-head-container">
            <div class="middle-top-container">
                <div class="middle-top-box-container">
                    <div class="logo-container" @click="userToHome">
                        <img class="img-100" alt="博雅美育浸润·五馆合一" src="../../assets/logo/logo.png">
                    </div>
                    <div class="head-slogan-container">
                        <div class="top-slogan-container">博雅美育浸润·五馆合一</div>
                        <div class="bottom-slogan-container">学贯东西 通识博雅 以美育心 以文化人</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-head-container">
        </div>
    </div>
</template>


<script>
import {timestampToTime} from "@/utils/date";
export default {
    name: "simpleHead",
    props: {
    },
    data() {
        return {
            timestampToTime,
        }
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() {},
    methods: {
        userToHome(){
            this.$router.push("/museum/home")
        },
    }

};
</script>

<style scoped lang="scss">
.home-head-container{
    width: 100%;
    height: 88.5px;
    border-bottom: 1.5px solid #b22222;
    display: flex;
    padding-top: 10px;
    box-sizing: border-box;
}
.left-header-container {
    width: 200px;
    height: 88px;
}
.middle-head-container {
    width: calc(100% - 400px);
    height: 88px;
    padding: 4px 0 4px 0;
    box-sizing: border-box;
}
.middle-top-container{
    width: 100%;
    height: 60px;
}
.middle-top-box-container{
    width: 314px;
    height: 60px;
    display: flex;
    margin: auto;
    padding: 2px 0 4px 0;
    box-sizing: border-box;
}
.logo-container{
    width: 54px;
    height: 54px;
    display: flex;
    cursor: pointer;
}
.head-slogan-container{
    width: calc(100% - 54px);
    height: 54px;
}
.top-slogan-container{
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-size: 18px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 3px;
    text-align: center;
}
.bottom-slogan-container{
    width: 100%;
    height: 20px;
    font-size: 13px;
    color: #4b5563;
    text-align: center;
    font-family: sans-serif;
    line-height: 20px;
}
.middle-bottom-container{
    width: 100%;
    height: 20px;
    text-align: center;
    font-size: 12px;
    font-family: sans-serif;
    color: #9ca3af;
    line-height: 20px;
}
.right-head-container {
    width: 200px;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-btn{
    padding: 0 10px 0 10px;
    height: 26px;
    text-align: center;
    color: #b22222;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #b22222;
    line-height: 26px;
    font-size: 14px;
    font-family: sans-serif;
    margin-left: 40px;
}
.login-btn:hover{

    color: #fff;
    background: #b22222;
    border: 1px solid #b22222;
}
@media (max-width: 1280px) {
    .left-header-container, .right-head-container { width: 120px; }
    .middle-head-container { width: calc(100% - 240px); }
    .top-slogan-container { font-size: 16px; letter-spacing: 2px; }
}
@media (max-width: 1024px) {
    .left-header-container, .right-head-container { display: none; }
    .middle-head-container { width: 100%; }
    .middle-top-box-container { margin-left: 20px; }
}
</style>